
import { defineComponent, PropType } from 'vue'

export default defineComponent({
  name: 'SvgLeftArrow',
  props: {
    color: {
      type: String as PropType<string>,
      default: '#2F2F2F'
    },
    width: {
      type: String,
      default: '24'
    },
    height: {
      type: String,
      default: '24'
    }
  }
})
